import { render } from "./CustomerDiscountGroupsManagement.html?vue&type=template&id=2cb1cdff&scoped=true"
import script from "./CustomerDiscountGroupsManagement.js?vue&type=script&lang=js"
export * from "./CustomerDiscountGroupsManagement.js?vue&type=script&lang=js"

import "./CustomerDiscountGroupsManagement.css?vue&type=style&index=0&id=2cb1cdff&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb1cdff"]])

export default __exports__